import { useDispatch, useSelector } from "react-redux";

// Actions
import { setDefaultFilters } from "redux/game/slice";

// Components
import Header from "components/organisms/Header";
import SkeletonHeader from "components/molecules/SkeletonHeader";

// Hooks
import { useLoaderStore } from "stores/loader";

// Selectors
import * as authSelectors from "redux/auth/selectors";

const HeaderContainer = () => {
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);
  const { overlayLoading } = useLoaderStore();

  const dispatch = useDispatch();

  const handleResetCategory = () => {
    dispatch(setDefaultFilters());
  };

  if (overlayLoading) {
    return <SkeletonHeader isAuthenticated={isAuthenticated} />;
  }

  return (
    <Header
      isAuthenticated={isAuthenticated}
      // eslint-disable-next-line react/jsx-handler-names
      resetCategory={handleResetCategory}
    />
  );
};

export default HeaderContainer;
